import { render, staticRenderFns } from "./MercadoLibre.vue?vue&type=template&id=51d19c14&"
import script from "./MercadoLibre.vue?vue&type=script&lang=js&"
export * from "./MercadoLibre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports